import { gql } from '@apollo/client';

export default class ServiceSettingsQuery {
    static GET_SERVICE_DEFAULT_SETTINGS = gql`
    query getServiceDefaultSettings($lotName: String!){ 
        getServiceDefaultSettings(lotName: $lotName){
            customerPayHourlyRate
            customerSubletPriceMarkUp
            hourlyLaborRate
            internalSubletPriceMarkUp
            shopSuppliesLimit
            shopSuppliesPercent
            minimumGP
            consentFormWording
            invoiceDisclaimer
            defaultFactoryWarranty
            hideApproveDeclineButtons
            multipleOpCodes
            storageFee
            warrantyPartMarkUp
            customTaxRateEnabled
            customTaxRateValue
            allowAddInventoryPartsFromProcess
            chargeSalesTaxASR
            chargeSalesTaxOnWarrantyDeductable
            chargeSalesTaxOnWarrantyParts
            shopSuppliesType
            roCostBasedOnHourlyRateMapping
    }}`;

    static GET_MINIMUM_GP_PER_LOTS = gql`
    query getMinimumGPPerLots{ 
        getMinimumGPPerLots{
            lotName
            minimumGP
    }}`;

    static GET_SERVICE_METADATA = gql`
    query getServiceMetadata{ 
        getServiceMetadata{
            entityMetadataId
            property
            label
            type
            displayed
            active
            taxable
            defaultValues {
                lotId
                defaultValue
            }
    }}`;
}
